// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Kyc_pageWrapper__SGoOx","pageForm":"Kyc_pageForm__0rJ1E"};